"use client";
import { Box } from "@chakra-ui/react";
import CardsList from "@/components/cardsList";
import { OPTIONS, TITLE } from "./constants";

const Options = () => {
  return (
    <Box id="services">
      <CardsList
        columns={{ base: 1, sm: 2, md: 4 }}
        title={TITLE}
        list={OPTIONS}
        spacing={{ base: 8, md: 12 }}
        hoverEffect
      />
    </Box>
  );
};

export default Options;
